import { Scope } from 'app/scopes'
import promiseRetry from 'promise-retry'
import { ComponentType } from 'react'
import lazyWithPreload from 'react-lazy-with-preload'
import { IndexRouteObject, NonIndexRouteObject } from 'react-router-dom'

import { ComponentWithTitle } from './component-with-title'
import { ProtectedRoute } from './protected-route'

/** Extending RouteObject with the function to preload lazy component in advance */
export type Route =
  | (Omit<IndexRouteObject, 'children'> & {
      children?: undefined
      preload?: () => Promise<ComponentType<any>>
    })
  | (Omit<NonIndexRouteObject, 'children'> & {
      children?: Array<Route>
      preload?: () => Promise<ComponentType<any>>
    })

export const buildRoute = ({
  path,
  factory,
  title,
  children,
  scopes = [],
}: {
  path: string
  factory: () => Promise<{ default: ComponentType<any> }>
  title?: string
  children?: Array<Route>
  scopes?: Array<Scope>
}): Route => {
  const Component = lazyWithPreload(() =>
    promiseRetry(retry => factory().catch(retry), {
      retries: 3,
    }),
  )

  return {
    path,
    children,
    preload: Component.preload,
    element: (
      <ProtectedRoute scopes={scopes}>
        <ComponentWithTitle title={title}>
          <Component />
        </ComponentWithTitle>
      </ProtectedRoute>
    ),
  }
}
